module.exports = __webpack_public_path__ + "img/GAME_TRAIN2.7016aada.jpg";